type ErrorTuple = [Error, null];
type SuccessTuple<T> = [null, T];

export async function to<T>(promise: Promise<T>): Promise<ErrorTuple | SuccessTuple<T>> {
  try {
    const result = await promise;
    return [null, result];
  } catch (e) {
    return [e as Error, null];
  }
}
